import {createReducer} from '@reduxjs/toolkit'
import {fetchCurrentMember} from '../actions/members'
import {CurrentMemberDetails} from '../types/state'

const defaultState: CurrentMemberDetails = {
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  email: undefined,
}

export const currentMemberDetails = createReducer(defaultState, builder => {
  builder.addCase(fetchCurrentMember.fulfilled, (state, action) => {
    const member = action.payload

    state.id = member?.id
    state.email = member?.loginEmail
    state.firstName = member?.firstName
    state.lastName = member?.lastName
  })
})
